import { SessionGroupOut } from "src/app/models/models";

/** Sort session checkbox items A–Z by description within each group; group order is unchanged. */
export function sortSessionGroupDetailsAlphabetically(groups: SessionGroupOut[] = []): SessionGroupOut[] {
	return (groups ?? []).map((group) => ({
		...group,
		details: [...(group?.details ?? [])].sort((a, b) =>
			(a?.description ?? "").localeCompare(b?.description ?? "", undefined, { sensitivity: "base" }),
		),
	}));
}
